import React from 'react';
import { Alert } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';

interface Props {
  source: string;
}

const MarkdownRenderer = (props: Props) => {
  const { source } = props;

  return (
    <ReactMarkdown
      components={{
        a: (props) => <Alert.Link href={props.href || '#'} target="_blank">{props.children}</Alert.Link>
      }}
    >
      {source}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
